import L from 'leaflet'

/**
 * Leaflet 1.x startet beim animierten Zoomen (setView/flyTo/Zoom-Tasten) einen 250-ms-Timer auf _onZoomTransitionEnd,
 * den map.remove() nicht abbricht. Verlässt man die Seite in dieser Zeit, wirft er
 * "Cannot read properties of undefined (reading '_leaflet_pos')". Einmaliger Schutz: nach dem Entfernen nichts mehr tun.
 */
let gepatcht = false
function leafletAbsichern() {
  if (gepatcht) return
  gepatcht = true
  const proto = L.Map.prototype as unknown as { _onZoomTransitionEnd?: (...a: unknown[]) => unknown }
  const orig = proto._onZoomTransitionEnd
  if (typeof orig !== 'function') return
  proto._onZoomTransitionEnd = function (this: { _mapPane?: unknown }, ...a: unknown[]) {
    if (!this._mapPane) return undefined
    return orig.apply(this, a)
  }
}
leafletAbsichern()

/**
 * Prüft, ob die Karte noch existiert (Panes vorhanden) und ihr Container noch im DOM hängt – vor setView/fitBounds/flyTo/
 * invalidateSize in Timeouts oder Beobachtern aufrufen, die nach dem Seitenwechsel noch laufen können.
 */
export function kartenLebt(map?: L.Map | null): map is L.Map {
  leafletAbsichern()
  if (!map) return false
  const m = map as unknown as { _mapPane?: HTMLElement; _container?: HTMLElement }
  return !!m._mapPane && !!m._container && m._container.isConnected
}
